import { render, staticRenderFns } from "./OptionPin.vue?vue&type=template&id=ecf02a84&"
import script from "./OptionPin.vue?vue&type=script&lang=js&"
export * from "./OptionPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports